import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { fetchPage } from './pageAPI';
import { Metadata, Content }  from '../../util/types';

export interface Page {
	metadata: Metadata;
	ktype: number;
	title: string;
	tag: string;
	content: Content;
}

export interface PageItem {
	metadata: Metadata;
	title: string;
	tag: string;
}

export interface PageViewResult {
	page: null | Page,
	errors: [string],
}

export interface PageForm {
	id: string | null;
	title: string;
	content: string;
	tag: string,
	labels: string[];
	ktype: number;
	star: boolean;
	kprivate: boolean;
}

export interface PageAddTextForm {
	id: string;
	content: string;
}

export interface PageSaveResponse {
	page: Page | null;
	errors: string;
}

export interface PageState {
	store: {[key:string]: Page};
    selected: {[key:string]: {[key:string]: boolean}};
}

export const toPageForm = (p: Page | null):PageForm  => {
	return {
		id: p ? p.metadata.id : null,
		title: p ? p.title : "",
		content: p ? p.content.content : "",
		tag: p ? p.tag : "",
		labels: [],
		ktype: p ? p.ktype : 1,
		star: false,
		kprivate: true,
	};
}

const initialState: PageState = {
  store: {},
  selected: {},
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(
  'page/fetchPage',
  async (amount: number) => {
    const response = await fetchPage(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const pageSlice = createSlice({
  name: 'page',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    addPage: (state, action: PayloadAction<Page>) => {
		console.log("addPage: ", action);
		if (action.payload.metadata.id) {
	  		state.store[action.payload.metadata.id] = action.payload;
		}
    },
    addPages: (state, action: PayloadAction<Page>) => {
		if (action.payload.metadata.id) {
	  		state.store[action.payload.metadata.id] = action.payload;
		}
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  /*
  extraReducers: (builder) => {
    builder
      .addCase(incrementAsync.pending, (state) => {
        state.selected = 'loading';
      })
      .addCase(incrementAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value += action.payload;
      })
      .addCase(incrementAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
  // */
});

export const { addPage, addPages } = pageSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectPages = (state: RootState) => state.page.store;

export default pageSlice.reducer;
